module.exports = __webpack_public_path__ + "img/1f4bd.0ade626.svg";